const enum RouteNames {
  Login = 'Login',
  Layout = 'Layout',

  Home = 'Home',
  InternalWeb = 'InternalWeb',
  Requirements = 'Requirements',

  // Mine
  Mine = 'Mine',
  My_AccountSettings = 'My_AccountSettings',
  My_Activities = 'My_Activities',
  My_Info = 'My_Info',
  My_Messages = 'My_Messages',

  // Error
  Error = 'Error',
  Error403 = '403',
  Error404 = '404',

  // SplitScreen
  SplitScreen = 'SplitScreen',
  SplitScreen_Redirect = 'SplitScreen_redirect',

  Guidance = 'Guidance',
  Settings = 'Settings',

  // DevTools
  DevTools = 'DevTools',
  DevTools_Playground = 'DevTools_Playground',

  // 组件
  ComponentDemo = 'Components',
  ComponentDemo_Base = 'ComponentDemo_Base',
  ComponentDemo_JsonEditor = 'ComponentDemo_JsonEditor',
  ComponentDemo_DiffText = 'ComponentDemo_DiffText',
  ComponentDemo_Table = 'ComponentDemo_Table',

  // 多级菜单
  MultiLevelMenu = 'MultiLevelMenu',
  MultiLevelMenu_Level1 = 'MultiLevelMenu_Level1',
  MultiLevelMenu_Level2 = 'MultiLevelMenu_Level2',
  MultiLevelMenu_Level3 = 'MultiLevelMenu_Level3',
}

export default RouteNames
